import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import React from "react";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
    },
    oops: {
        fontSize: 35,
        padding: 10,
    },
    pageNotFound: {
        fontSize: 40,
        padding: 10,
    },
}));

const goBackHome = (history) => () => history.push("/");

const PageNotFound = () => {
    const classes = useStyles();
    const history = useHistory();
    return (
        <Box
            height="100vh"
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            className={classes.root}
        >
            <SentimentVeryDissatisfiedIcon
                style={{ fontSize: 70 }}
                color="primary"
            />
            <Typography component="h1" variant="h1" className={classes.oops}>
                Desculpe!
            </Typography>
            <Typography variant="h3" className={classes.pageNotFound}>
                Essa página não existe
            </Typography>
            <Button
                onClick={goBackHome(history)}
                fullWidth={false}
                color="primary"
            >
                Voltar ao app
            </Button>
        </Box>
    );
};

export { PageNotFound };
